module.exports = __webpack_public_path__ + "static/media/male-avatar.b77a40cb.svg";